/**
 * Owner: Pavit Gogia
 * Expiry: 2026-10-15
 * Cleanup: https://github.com/Borradh-Media/borradh-workspace/issues/1126
 */
export const CLAIRE_CONTENT_MUSIC_EDITOR_FLAG =
  'rollout-claire-content-music-editor';
